import api, { unwrap } from './client';

// Plan des ventes : les affaires qui soutiennent la prévision, leur répartition et les réglages.
export const getCoverage = (tenantId, year) => unwrap(api.get(`/sales-plan/${tenantId}/${year}`));
export const addDeal = (tenantId, payload) => unwrap(api.post(`/sales-plan/${tenantId}`, payload));
export const updateDeal = (tenantId, dealId, payload) =>
  unwrap(api.patch(`/sales-plan/${tenantId}/deals/${dealId}`, payload));
export const deleteDeal = (tenantId, dealId) => unwrap(api.delete(`/sales-plan/${tenantId}/deals/${dealId}`));
export const setDealYear = (tenantId, dealId, year, amount) =>
  unwrap(api.put(`/sales-plan/${tenantId}/deals/${dealId}/${year}`, { amount }));
export const setCoverageSettings = (tenantId, year, payload) =>
  unwrap(api.put(`/sales-plan/${tenantId}/${year}/settings`, payload));
export const carryForward = (tenantId, dealId, year) =>
  unwrap(api.post(`/sales-plan/${tenantId}/deals/${dealId}/carry/${year}`));
